import React, { createContext } from 'react';

export interface ModalContextType {
    openModal: (modalId: string, props?: Record<string, any>) => void;
    closeModal: (modalId: string) => void;
    isModalOpen: (modalId: string) => boolean;
    modalConfig: ModalConfig;
    closeAllModals: () => void;
}

export interface ModalConfig {
    [key:string]: {
        id: string;
        modalComponent: React.FC;
    }
}

// Create the ModalContext with a default value of undefined
export const ModalContext = createContext<ModalContextType | undefined>(undefined);
